import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "CoreDialog",
    {
      attrs: {
        "data-qa": "dialog-spec-not-available-modal",
        value: _vm.isShowDialog,
        transition: "fade-transition",
        size: "sm",
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                VBtn,
                {
                  attrs: {
                    "data-qa": "modal-actions-btn-close",
                    color: "primary",
                    text: "",
                  },
                  on: { click: _vm.hideDialog },
                },
                [_vm._v("\n      Понятно\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(VImg, {
        staticClass: "mx-auto mb-2",
        attrs: {
          src: "/static/_v1/pd/mascots/speciality-empty.svg",
          alt: "Маскот ПроДокторов - не найдено",
          height: "175px",
          width: "175px",
          contain: "",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-h6 text--text mb-2" }, [
        _vm._v("\n    Таких врачей в городе нет\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-body-1 text-secondary--text" },
        [
          _vm._v("\n    Врачей\n    "),
          _vm.chosenSpeciality && _vm.isSpecialityVisible
            ? [
                _vm._v(
                  "\n      по специальности " +
                    _vm._s(_vm.chosenSpeciality) +
                    "\n    "
                ),
              ]
            : _vm._e(),
          _vm._v("\n    " + _vm._s(_vm.subtitleText) + " нет.\n  "),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }